import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {StyledCommentsList} from './comments.styled';
import BllinkUtils from '../../common/utils/utils';

const BllinkTime = BllinkUtils.BllinkTime;

export default function CommentsList({commentsList}) {
    const {t} = useTranslation();
    const userData = useSelector((state) => state.auth.user);

    const isMyComment = (owner) => {
        return owner === userData.email;
    }

    return (
        <StyledCommentsList>
            <ul className='comments-list'>
                {
                    commentsList && commentsList.length > 0 ? commentsList.map(comment => (
                        <li
                            key={comment.id}
                            className={`comment ${isMyComment(comment.createdBy) ? 'is-my' : ''}`}
                        >
                            <div className="data">
                                <span className="time">{new Date(comment.updatedAt).toLocaleTimeString()}</span>
                                <span className="date">
                                    {BllinkTime.parseDate(comment.updatedAt)}
                                </span>
                                <span className="name">{isMyComment(comment.createdBy) ? t('comments.you') : (comment.User?.firstName || comment.createdBy)}</span>
                            </div>
                            <p>{comment.text}</p>
                        </li>
                    )) : (<p className="text-center mt-3">{t('comments.empty')}</p>)
                }
            </ul>
        </StyledCommentsList>
    )
}